import React, { useEffect, useState } from "react";
import { EditBlockOption } from "../EditBlock";
import { OptionIsRight, TopicType } from "../../../../../service/homework";
import _ from "underscore";
import { EditDanXuanPure } from "../../../../exam/addExam/components/EditDanXuan";
import { EditBlock } from "../EditBlock";
import { QuestionType } from "../../../../../service/service";

interface EditDuoxuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange?: (topic: TopicType) => void;
}

export default function EditDanXuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditDuoxuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    useEffect(() => {
        setInnerTopic(topic);
    }, [topic]);

    const onInputChange = (index: number, value: string) => {
        const newTopic = { ...innerTopic };
        newTopic.answers[index].content = value;
        setInnerTopic(newTopic);
    };

    const onCheckChange = (index: number) => {
        const answers = innerTopic.answers.map((item, itemIndex) => ({
            ...item,
            isRight:
                itemIndex === index ? OptionIsRight.Right : OptionIsRight.Wrong
        }));
        setInnerTopic({ ...innerTopic, answers });
    };

    const getValue = () => {
        return _.findIndex(innerTopic.answers, {
            isRight: OptionIsRight.Right
        });
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    const deleteItem = (index: number) => {
        const newTopic = { ...innerTopic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const addItem = () => {
        const newTopic = { ...innerTopic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Wrong });
        setInnerTopic(newTopic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.DanXuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditDanXuanPure
                blockOption={blockOption}
                innerTopic={innerTopic}
                onCheckChange={onCheckChange}
                onInputChange={onInputChange}
                getValue={getValue}
                addItem={addItem}
                deleteItem={deleteItem}
            />
        </EditBlock>
    );
}
